import { endOfDay, isAfter } from 'date-fns';

import { parseDate } from '@utils/date';

import type { JobState } from 'types/jobs';

export type JobLifecycle = 'archived' | 'expired' | 'published' | 'draft';

type LifecycleJob = {
  isPublished: boolean;
  isArchived: boolean;
  deadline: string | null;
};

/** Matches the Expired tab's query (`searchJobs`): published and past its deadline. */
export const isJobExpired = (job: LifecycleJob) => {
  if (!job.isPublished || !job.deadline) return false;
  return isAfter(new Date(), endOfDay(parseDate(job.deadline)));
};

export const jobState = (job: LifecycleJob): JobLifecycle => {
  if (job.isArchived) return 'archived';
  if (isJobExpired(job)) return 'expired';
  if (job.isPublished) return 'published';
  return 'draft';
};

/** The tabs are keyed on the plural, the lifecycle on the singular. */
export const JOB_LIFECYCLE_TAB: Record<JobLifecycle, JobState> = {
  archived: 'archived',
  expired: 'expired',
  published: 'published',
  draft: 'drafts',
};

export const jobListTab = (job: LifecycleJob): JobState => JOB_LIFECYCLE_TAB[jobState(job)];
